import type { TopicViewModel } from '@trinnvis/dabih-api-client';
import { translateTemplateName } from 'src/i18n/template-content';

export function toTopicViewModel(item: TopicViewModel): TopicViewModel {
  return { ...item, name: translateTemplateName(item.name) };
}
